import React from 'react'
import './search_form.scss'
import { bindSearchForm } from "../../top/index/search_form_binder"
import { loadPikadayIfNeeded } from "../../top/index/pikaday_loader"
import { withNamespaces } from "react-i18next"

class SearchForm extends React.Component {
  componentDidMount() {
    bindSearchForm('vn')
    loadPikadayIfNeeded()
  }

  addDays(date, days) {
    const daysInSeconds = days * 24 * 60 * 60 * 1000
    return new Date(date.getTime() + daysInSeconds)
  }

  ymd(date) {
    const y = date.getFullYear()
    const m = ('0' + (date.getMonth() + 1)).slice(-2)
    const d = ('0' + date.getDate()).slice(-2)
    return `${y}-${m}-${d}`
  }

  get minCheckin() {
    return new Date()
  }

  get minCheckout() {
    return this.addDays(this.minCheckin, 1)
  }

  get maxCheckin() {
    return this.addDays(this.minCheckin, 365 * 2)
  }

  get maxCheckout() {
    return this.addDays(this.minCheckout, 365 * 2)
  }

  render() {
    const { t } = this.props
    return (
      <div styleName="search-form-container">
        <form action={routeUrlHelper.countrySearchPath('vn')} styleName="search-form " className="js-search-form" method="get" name="searchForm" data-bound="true">
          <div styleName="search-form-input-group">
            <div styleName="place-search-box">
              <label styleName="place-search-label" htmlFor="description">{t('vietnam.place')}</label>
              <input aria-label={t('vietnam.place')} styleName="place-search-input" className="js-place-search-input" id="description" name="destinationSearch" placeholder={t('vietnam.place_placeholder')} type="text" autoComplete="off"/>
            </div>
            <div styleName="date-range-container">
              <div styleName="date-range-input-container" className="js-date-range-input-container">
                <label styleName="date-range-label" htmlFor="checkin">{t('vietnam.checkin_input_label')}</label>
                <input aria-label={t('vietnam.checkin_input_placeholder')}
                  styleName="date-range-input" className="js-date-range-input"
                  id="checkin" max={this.ymd(this.maxCheckin)}
                  min={this.ymd(this.minCheckin)} name="checkin"
                  placeholder={t('vietnam.checkin_input_placeholder')} type="date"
                  autoComplete="off" />
              </div>
              <div styleName="date-range-input-container" className="js-date-range-input-container">
                <label styleName="date-range-label" htmlFor="checkout">{t('vietnam.checkout_input_label')}</label>
                <input aria-label={t('vietnam.checkout_input_placeholder')}
                  styleName="date-range-input"
                  className="js-date-range-input"
                  id="checkout" max={this.ymd(this.maxCheckout)}
                  min={this.ymd(this.minCheckout)} name="checkout"
                  placeholder={t('vietnam.checkout_input_placeholder')} type="date"
                  autoComplete="off" />
              </div>
              <div styleName="pikaday-container" className="js-pikaday-container">
              </div>
            </div>

            <div styleName="select-guests">
              <label styleName="select-guests-label" htmlFor="adults">{t('vietnam.adults_input_label')}</label>
              <div styleName="select-guests-wrap">
                <select aria-label={t('vietnam.adults_input_label')} styleName="adults-select" id="adults" name="adults">
                  { Array.from(Array(15)).map((_, i) => <option key={i} value={ i > 0 ? i + 1 : '' } selected={i == 1}>{t('vietnam.adults_option', { count: i + 1 })}</option>) }
                </select>
              </div>
            </div>

            <div styleName="submit-btn">
              <button styleName="btn-primary" className="extended" type="submit">
                <span className="vs-icon-search"></span>
                <span styleName="btn-label">検索</span>
              </button>
            </div>
            <input className="js-hidden-destination-input" type="hidden" name="destination"/>
            <input name="lat" type="hidden"/>
            <input name="lon" type="hidden"/>
            <input name="radius" type="hidden"/>
            <input name="sort" type="hidden" value="distance_asc"/>
          </div>
        </form>
      </div>
    )
  }
}

export default withNamespaces('vietnam')(SearchForm)
